import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { usePortfolio } from '@/context/PortfolioContext';
import { getProblemIcon } from '@/constants/problemSolvedIcons';
import {
  SectionShell,
  SectionInner,
  SectionHeader,
  SectionLoading,
  SectionError,
} from '@/components/section/sectionLayout';

const ProblemsSolved = () => {
  const { portfolioData, loading, error } = usePortfolio();

  if (loading) return <SectionLoading id="problems-solved" />;
  if (error) return <SectionError id="problems-solved" error={error} />;

  const problemsSolved = portfolioData?.problemsSolved || [];

  return (
    <SectionShell id="problems-solved">
      <SectionInner>
        <SectionHeader
          title="Problèmes que je"
          highlight="résous"
          description="Des solutions techniques adaptées à vos besoins spécifiques"
        />

        {problemsSolved.length === 0 ? (
          <p className="text-center text-gray-600 dark:text-gray-400">Aucun contenu à afficher.</p>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
            {problemsSolved.map((problem, index) => {
              const Icon = getProblemIcon(problem.icon);
              const key = problem.id ?? problem._id ?? index;
              return (
                <Card
                  key={key}
                  className="h-full border-gray-200 bg-white dark:border-[#1f2937] dark:bg-[#1a1f2e] motion-safe:transition-shadow motion-safe:hover:shadow-lg motion-safe:hover:shadow-emerald-500/10"
                >
                  <CardHeader className="pb-2">
                    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-500/10 sm:mb-4 sm:h-12 sm:w-12">
                      <Icon className="h-5 w-5 text-emerald-400 sm:h-6 sm:w-6" />
                    </div>
                    <CardTitle className="text-base text-gray-900 dark:text-white sm:text-lg">
                      {problem.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400 sm:text-base">
                      {problem.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </SectionInner>
    </SectionShell>
  );
};

export default ProblemsSolved;
